import { createFileRoute } from "@tanstack/react-router";
import { redirectTo } from "@/lib/route-redirect";
export const Route = createFileRoute("/hosting/vps")({ beforeLoad: redirectTo("/hosting/vps-cloud") });
